import LangEnum from '../../../../../lang/LangEnum';
import { CatalogSectionSortCriterionEnum } from '../../../enums/catalogSectionSortCriterion.enum';
import { CATALOG_VIEW_GROUP_BY_OPTIONS, CATALOG_VIEW_SORT_OPTIONS } from './catalogView.consts';
import { CatalogViewCombination, CatalogViewGroupBy, CatalogViewOption } from './catalogView.types';

const BLOCKED_REASON = LangEnum.CATALOGS_VIEW_MANUAL_REQUIRES_MANUAL_GROUP;

export const getIsViewCombinationValid = ({
  sortCriterion,
  groupBy,
}: CatalogViewCombination): boolean =>
  sortCriterion !== CatalogSectionSortCriterionEnum.MANUAL || groupBy === CatalogViewGroupBy.MANUAL;

export const resolveSortOptions = ({
  sortCriterion,
  groupBy,
}: CatalogViewCombination): CatalogViewOption<CatalogSectionSortCriterionEnum>[] => {
  if (groupBy === CatalogViewGroupBy.MANUAL) {
    return CATALOG_VIEW_SORT_OPTIONS;
  }

  return CATALOG_VIEW_SORT_OPTIONS.map((option) => {
    if (option.value !== CatalogSectionSortCriterionEnum.MANUAL || option.value === sortCriterion) {
      return option;
    }

    return { ...option, isDisabled: true, blockedReason: BLOCKED_REASON };
  });
};

export const resolveGroupOptions = ({
  sortCriterion,
  groupBy,
}: CatalogViewCombination): CatalogViewOption<CatalogViewGroupBy>[] => {
  if (sortCriterion !== CatalogSectionSortCriterionEnum.MANUAL) {
    return CATALOG_VIEW_GROUP_BY_OPTIONS;
  }

  return CATALOG_VIEW_GROUP_BY_OPTIONS.map((option) => {
    if (option.value === CatalogViewGroupBy.MANUAL || option.value === groupBy) {
      return option;
    }

    return { ...option, isDisabled: true, blockedReason: BLOCKED_REASON };
  });
};
